import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
} from '@angular/core';

@Component({
  selector: 'hdi-burger-menu',
  standalone: true,
  imports: [],
  templateUrl: './burger-menu.component.html',
  styleUrls: ['./burger-menu.component.scss'],
})
export class BurgerMenuComponent implements AfterViewChecked {
  @Output() triggerMenu = new EventEmitter();
  @Input() closeMenu: boolean = false;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef
  ) {}

  ngAfterViewChecked(): void {
    if (this.closeMenu) {
      const menuButton = this.el.nativeElement.querySelector('.burger-menu');
      if (menuButton) {
        this.renderer.removeClass(menuButton, 'open');
      }
    }
  }

  toggleMenu() {
    const menuButton = this.el.nativeElement.querySelector('.burger-menu');
    if (menuButton) {
      const isOpened = menuButton.classList.contains('open');
      if (isOpened) {
        this.renderer.removeClass(menuButton, 'open');
      } else {
        this.renderer.addClass(menuButton, 'open');
      }
    }
    this.triggerMenu.emit();
  }
}
